import log from "loglevel";
import { inject, injectable } from "tsyringe";
import { TOKEN_IProjectBus, type IProjectBus } from "./ProjectBus";

export const TOKEN_ITabFocusService = Symbol('ITabFocusService');

/**
 * Monitors tab focus/blur events and dispatches events to ProjectBus
 */
export interface ITabFocusService {
    /**
     * Initializes the focus/blur event listeners
     */
    initialize(): void;
}

@injectable()
export class TabFocusService implements ITabFocusService {
    constructor(
        @inject(TOKEN_IProjectBus) private projectBus: IProjectBus
    ) {
        this.initialize();
    }

    public initialize(): void {
        window.addEventListener('focus', this.handleFocus);
        window.addEventListener('blur', this.handleBlur);

        log.info("TabFocusService initialized");
    }

    private handleFocus = (): void => {
        log.info("Tab gained focus");
        this.projectBus.tabFocusChanged(true);
    };

    private handleBlur = (): void => {
        log.info("Tab lost focus");
        this.projectBus.tabFocusChanged(false);
    };
}